import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _findLast from 'lodash/findLast';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Core components
import MenuButton from 'components/core/MenuButton';
import Tooltip from 'components/core/Tooltip';
// Models
import mAsync from 'models/async';
import mDevice from 'models/device';
// Custom
import { asyncOperationDataShape, deviceDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';

const AsyncStatusIcon = ({ status }) => {
  const { icon, color } = mAsync.statusIcon(status);
  return (
    <Tooltip content={<LocalizedMessage id="tooltip.syncStatus" values={{ status }} />}>
      <AppIcon id={icon} color={color} />
    </Tooltip>
  );
};

AsyncStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
};

const ResourceAsyncStatusIcon = ({ resource, asyncOperation, devices }) => {
  // Get async status information
  const { globalStatus, devicesStatus } = mAsync.status(asyncOperation, resource, devices);

  if (!_isEmpty(devices) && !_isEmpty(devicesStatus)) {
    return (
      <MenuButton
        buttonComp={(
          <AsyncStatusIcon status={globalStatus} />
        )}
        items={
          _map(devicesStatus, ({
            key, status, statusText, device,
          }) => {
            const asyncStatusIcon = mAsync.statusIcon(status);
            return {
              key,
              label: <LocalizedMessage id={statusText} />,
              secondaryLabel: mDevice.installationDesc(device),
              icon: <AppIcon id={asyncStatusIcon.icon} color={asyncStatusIcon.color} />,
              visible: true,
            };
          })
        }
        withoutObj
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        transformOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      />
    );
  }
  return (
    <div style={{ marginLeft: '6px' }}>
      <AsyncStatusIcon status={globalStatus} />
    </div>
  );
};

ResourceAsyncStatusIcon.propTypes = {
  resource: PropTypes.object.isRequired,
  idKey: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  devices: PropTypes.arrayOf(deviceDataShape).isRequired,
  asyncOperation: asyncOperationDataShape,
};

ResourceAsyncStatusIcon.defaultProps = {
  asyncOperation: null,
};

const mapStateToProps = (state, ownProps) => ({
  asyncOperation: _findLast(state.asyncOperation.list, [ownProps.idKey, ownProps.resource.id]),
  devices: state.deviceData.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ResourceAsyncStatusIcon);



// WEBPACK FOOTER //
// ./components/items/ResourceAsyncStatusIcon.js